import React, { useState } from "react";
import { Card, CardBody, Button, Alert } from "reactstrap";
import { createStripeDashboardLink } from "../../../helpers/paymentsApi";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * "View in Stripe" — opens the landlord's Stripe Express Dashboard in a
 * new tab. Always mints a fresh, single-use login link from the backend
 * right before navigating; never reuses/stores a previous link.
 */
const StripeDashboardButton = () => {
  const { status } = useStripeConnect();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!status?.connected) return null;

  const openDashboard = async () => {
    setLoading(true);
    setError("");
    try {
      const { url } = await createStripeDashboardLink();
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) {
      console.error("Create Stripe dashboard link error:", e);
      setError("Couldn't open the Stripe Dashboard. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mb-4">
      <CardBody className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <h5 className="mb-1">Stripe Dashboard</h5>
          <p className="text-muted mb-0">
            For additional payout, tax, and account details, open your Stripe Express Dashboard.
          </p>
          {error && <p className="text-danger small mb-0 mt-1">{error}</p>}
        </div>
        <Button color="secondary" outline onClick={openDashboard} disabled={loading}>
          {loading ? "Opening…" : "View in Stripe"}
        </Button>
      </CardBody>
    </Card>
  );
};

export default StripeDashboardButton;
